<app-dialog-header [title]="'QUIZ.LABEL.ALLOWED_NUMBER_OF_ATTEMPTS'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24 pb-0" fxLayout="column" fxLayoutAlign="start">
    <mat-form-field>
        <mat-label>{{ 'QUIZ.LABEL.ALLOWED_NUMBER_OF_ATTEMPTS' | translate }}</mat-label>
        <input matInput type="number" min="2" [formControl]="valueCtrl" (keydown.enter)="save.emit({ value: valueCtrl.value, isUnlimited })" />
    </mat-form-field>
</div>
<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="space-between center">
    <mat-slide-toggle [(ngModel)]="isUnlimited" (change)="updateToggleButton()">{{ 'QUIZ.BUTTON.UNLIMITED_ATTEMPTS' | translate }}</mat-slide-toggle>

    <div fxLayoutAlign="flex-end center">
        <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
        <app-flat-button
            [label]="'GENERAL.BUTTON.SAVE'"
            (onClick)="save.emit({ value: valueCtrl.value, isUnlimited })"
            [disabled]="(!valueCtrl.valid || !valueCtrl.dirty) && !isUnlimitedChanged"
        ></app-flat-button>
    </div>
</div>
